import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { BetaCheckbox } from '@bevy/bevy-design-system';

/**
 * React Hook From Controlled Checkbox Input
 * @param {string} name
 * @param {string} label
 * @param {string} ariaLabel
 * @param {object} rules
 * @see {Documentation} https://react-hook-form.com/docs/usecontroller
 * @returns {React.Component}
 */
const ControlledCheckboxInput = ({ name, label, ariaLabel, rules = { required: false } }) => {
  const { control } = useFormContext();
  const {
    field: checkboxField,
    fieldState: { error },
  } = useController({ name, control, rules });

  return (
    <div data-help-id={name}>
      <BetaCheckbox
        size='small'
        name={name}
        label={label}
        ariaLabel={ariaLabel}
        value={checkboxField.value}
        onChange={checkboxField.onChange}
        errors={error ? [error?.message] : null}
      />
    </div>
  );
};

ControlledCheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  rules: PropTypes.object,
};

export default ControlledCheckboxInput;
